import React, { useEffect } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import { useItemsFine } from "../_actions/app/items";
import { Button, Table } from "antd";
import log from "cslog";
import { isPresetStatusColor } from "antd/es/_util/colors";
import { history } from "../_helpers/history";
import AddCategoryModal from "./AddCategoryModal";

// const COLORS_ARR = [
//     "#ffc67d",
//     "#e5d8b6",
//     "#99cc00",
//     "#66b3ff",
//     "#ff99cc",
//     "#0099cc",
//     "#ffcc00",
//     "#33ccff",
//     "#8bc34a",
//     "#ff6699",
//     "#00e5ff",
//     "#ccff00",
//     "#b3e5fc",
//     "#00ccbb",
// ];

const COLORS_ARR = [
    "#ece0ffff",
    "#fff8cfff",
    "#ffdfe4ff",
    "#dbeaffff",
    "#ffffdcff",
    "#fff0e0ff",
    "#e3f8feff",
    "#edd9ffff",
    "#ffe1f0ff",
];

function CategoryMap() {
    const { isSuccess, isLoading, data } = useItemsFine(
        "qdb_post_types",
        // "filter[parent][_null]=true&fields=display_name,categories.*,presets.*,children.*",
        "fields=id,display_name,categories.*,presets.qdb_creation_schema_id.name,presets.qdb_creation_schema_id.id,parent",
        true
    );
    const [rows, setRows] = React.useState([]);

    const addChildren = (parent, data, level = 0, pre_row = {}, index = 0) => {
        // takes parent, finds children and return table rows with children
        const out = [];
        const my_children = data.filter((item) => item.parent === parent.id);
        if (my_children.length === 0) return [pre_row];
        my_children.forEach((item, child_index) => {
            const child_count = child_index === 0 ? my_children.length : 0;
            const row = {
                ...pre_row,
                key: item.id,
                [`level${level}`]: parent.display_name,
                // [`level${level}`]: `${parent.display_name}: ${child_count}`,
                [`level${level + 1}`]: item.display_name,
                presets: item.presets?.map((ii) => ii.qdb_creation_schema_id),
                color: COLORS_ARR[index],
                children_count: child_count,
            };
            const new_row = addChildren(item, data, level + 1, row, index);
            out.push(...new_row);
        });
        return out;
    };

    useEffect(() => {
        if (isSuccess) {
            const out = [];
            data.filter((item) => item.parent === null).forEach(
                (item, index) => {
                    out.push(...addChildren(item, data, 0, {}, index));
                }
            );
            setRows(out);
        }
    }, [isSuccess, data]);

    log.d(rows, "Rows in CMM");

    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Category Map"
                    // children={[<Button type="primary">Add Post Type</Button>]}
                    children={[
                        <AddCategoryModal
                            trigger={
                                <Button type="primary">Add Post Type</Button>
                            }
                        />,
                    ]}
                />
            }
        >
            <div style={{ padding: "15px" }}>
                <Table
                    size="middle"
                    columns={[
                        {
                            key: "level0",
                            title: "Level 0",
                            dataIndex: "level0",
                            minWidth: 300,
                            onCell: (record, index) => {
                                return {
                                    rowSpan: record?.children_count,
                                };
                            },
                        },
                        {
                            key: "level1",
                            title: "Level 1",
                            dataIndex: "level1",
                            minWidth: 300,
                        },
                        // {
                        //     key: "level2",
                        //     title: "Level 2",
                        //     dataIndex: "level2",
                        // },
                        {
                            key: "presets",
                            title: "Presets",
                            dataIndex: "presets",
                            render: (_, { presets }) => {
                                // return <div>{presets?.join(", ")}</div>;
                                return (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: "5px",
                                            flexWrap: "wrap",
                                        }}
                                    >
                                        {presets?.map((ii) => (
                                            <div
                                                style={{
                                                    backgroundColor:
                                                        "#f0f0f06b",
                                                    // backgroundColor: color,
                                                    padding: "3px 8px",
                                                    borderRadius: "5px",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    history.push(
                                                        `/design-admin/templates-manager/${ii.id}`
                                                    );
                                                }}
                                            >
                                                {ii?.name}
                                            </div>
                                        ))}
                                    </div>
                                );
                            },
                        },
                    ]}
                    dataSource={rows}
                    pagination={false}
                    bordered
                    rowHoverable={false}
                    onRow={(record, index) => {
                        return {
                            style: {
                                backgroundColor: record.color,
                            },
                        };
                    }}
                />
            </div>
        </QurealSection>
    );
}

export default CategoryMap;
